import React, { FC } from 'react';
import { Icon, IconButton } from '@kontentino/ui';
import dayjs, { Dayjs } from 'dayjs';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';

type Props = Pick<
  ReactDatePickerCustomHeaderProps,
  'decreaseMonth' | 'increaseMonth' | 'date'
> & {
  minDate?: Dayjs;
  maxDate?: Dayjs;
};

const DatePickerHeaderMonthPeriod: FC<Props> = ({
  decreaseMonth,
  increaseMonth,
  date,
  minDate,
  maxDate,
}) => {
  const monthYearLabel = dayjs(date).format('MMMM YYYY');

  const isNextMonthDisabled = maxDate
    ? dayjs(date).add(1, 'month').isAfter(maxDate)
    : false;
  const isPreviousMonthDisabled = minDate
    ? dayjs(date).subtract(1, 'month').isBefore(minDate)
    : false;

  return (
    <div className="tw-flex tw-items-center tw-justify-between">
      <IconButton
        onClick={decreaseMonth}
        variant="light"
        icon={<Icon size={'md'} icon={faChevronLeft} />}
        size={'small'}
        disabled={isPreviousMonthDisabled}
      />
      <span className="tw-text-md">{monthYearLabel}</span>
      <IconButton
        onClick={increaseMonth}
        variant="light"
        icon={<Icon size={'md'} icon={faChevronRight} />}
        size={'small'}
        disabled={isNextMonthDisabled}
      />
    </div>
  );
};

export default DatePickerHeaderMonthPeriod;
